
import { httpGet } from "../Web"
import { ApiResponse } from "./ApiResponse"

export interface Product {
    id: number,
    guid: string,
    name: string,
    companyId: number,
    status: number
};

export const getProducts = (abortController: AbortController): Promise<ApiResponse<Product[]>> =>
    httpGet('/api/product/', abortController);

export const getProduct = (productId: number, abortController: AbortController): Promise<ApiResponse<Product>> =>
    httpGet(`/api/product/get/${productId}`, abortController);